import { boundsToString } from '../utils';
import { fetchGet } from '../fetch';
const gridSectionBase = (boundingBox, format, signal) => {
    const requestOptions = {
        'bounding-box': boundsToString(boundingBox),
    };
    if (format !== undefined) {
        requestOptions['format'] = format;
    }
    return fetchGet('grid-section', requestOptions, signal);
};
export const gridSection = (boundingBox, signal) => gridSectionBase(boundingBox, 'json', signal);
export const gridSectionGeoJson = (bbox, signal) => gridSectionBase(bbox, 'geojson', signal);
//# sourceMappingURL=grid-section.js.map